import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import { SearchTermProvider } from "./SearchTermContext";
ReactDOM.render(
  <React.StrictMode>
    <SearchTermProvider>
      <App />
    </SearchTermProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
